import React, { Component } from 'react';
import FX from './functions/functions';
import './css/SearchBox.css';
//import logo from './logo.svg';
class SearchBox extends Component {
    constructor(props) {
      super(props);
      this.state = {selected:0, show: [1], list: [], searchText:''};
      this.capture = this.capture.bind(this);
      this.selectItem = this.selectItem.bind(this);
      this.selectedTop = this.selectedTop.bind(this);
      this.handleST = this.handleST.bind(this);
      this.filter = this.filter.bind(this);
      this.focus = this.focus.bind(this);
    }
		componentWillUpdate(nextProps, nextState){
		  if (1 || this.state.searchText !== nextState.searchText){
		    if(document.getElementById('prodListPopup')){
		       document.getElementById('prodListPopup').scrollTop = 0;
		    }
		    nextState.list = this.filter(nextState.searchText);
		    //nextState.selected = 0;
		    if(nextState.list.length === 0 && nextState.searchText.length > this.state.searchText.length){
          var audio = new Audio('/media/break.mp3');
          audio.play();
		    }
		  }
		}
		componentDidUpdate(prevProps, prevState){
		  if(!!this.state.searchText){
		  this.focus();
		  document.getElementById("prod_search").value = document.getElementById("prod_search").value;
      }
		}
		focus(){
		  if(!!this.state.searchText){
		     setTimeout(() => {
		        if(document.getElementById("prod_search")){
		        document.getElementById("prod_search").focus();
            document.getElementById("prod_search").setSelectionRange(document.getElementById("prod_search").value.length, document.getElementById("prod_search").value.length);
		      }
		     }, 20);
      }
		}
		filter(searchText){
	      if(this.props.root.state.current_customer && this.props.root.state.current_customer.products && this.props.root.state.current_customer.products.list){
		        var prods= [];
	          if(this.props.root.state.current_customer.products.list){
	            prods = this.props.root.state.current_customer.products.list;
	          }
	          else{
              for(var i = 0; i < this.props.root.state.customers.length;i++){
                if(this.props.customer_id === this.props.root.props._root.state.customers[i].id){
                  prods = this.props.root.props._root.state.customers[i].product;
                  break;
                }
              }
	          }
		        var tbo  = [];
		        prods.forEach(( prod ) => {
                 if(parseInt(prod.ignore, 10) !== 1 && !prod.composite && (this.state.show.indexOf(prod.status) !== -1) &&
                  ((prod.sku && prod.sku.toString().toUpperCase().indexOf(searchText.toUpperCase()) >= 0) ||
                  (prod.name && prod.name.toString().toUpperCase().indexOf(searchText.toUpperCase()) >= 0) ||
                  (prod.barcode && prod.barcode.toString().toUpperCase().indexOf(searchText.toUpperCase()) >= 0))){
                   tbo.push( prod );
                 }
            });
            return tbo;
        }
        return [];
		}
		handler = (tgt, e) => {
		}
		capture(e){
          var pl = this.filter(this.state.searchText);
          switch(e.keyCode){
            case 13:
              console.log(this.state);
              console.log(this.state.searchText);
              console.log(this.filter(this.state.searchText));
              console.log(this.filter(this.state.searchText)[this.state.selected]);
              console.log(this.state.selected);
              console.log(e.target);
              this.selectItem.bind(null,this.filter(this.state.searchText)[this.state.selected])();
              e.preventDefault();
              e.stopPropagation()
              break;
            case 27:
              this.props.root.setState({searchText:''});
              if (document.getElementById("searchBox"))
		              document.getElementById("searchBox").focus();
              e.preventDefault();
              e.stopPropagation()
              break;
            case 33:
              this.setState({selected:0});
                this.selectedTop(0);
                e.preventDefault();
                e.stopPropagation()
              break;
            case 34:
                this.setState({selected:pl.length-1});
                this.selectedTop(pl.length-1);
                e.preventDefault();
                e.stopPropagation()
              break;
            case 38:
              if(this.state.selected > 0){
              this.setState({selected:this.state.selected-1});
              this.selectedTop(this.state.selected-1);
              }
              else if (this.state.selected !== 0) {
              this.setState({selected:0});
              }
              e.preventDefault();
              e.stopPropagation()
              break;
            case 40:
              if(this.state.selected < pl.length-1){
                this.setState({selected:this.state.selected+1});
                this.selectedTop(this.state.selected+1);
              }
              else if (this.state.selected !== pl.length-1) {
                this.setState({selected:pl.length-1});
              }
          e.preventDefault();
              e.stopPropagation();
              break;
            default:
          }
		}
		selectedTop(sel){
		  if(document.getElementById('id_' + sel)){
		      if(document.getElementById('id_' + sel).offsetTop < document.getElementById('prodListPopup').scrollTop){
		         document.getElementById('prodListPopup').scrollTop = document.getElementById('id_' + sel).offsetTop  - 20;

		      }

		      if((document.getElementById('prodListPopup').scrollTop + document.getElementById('prodListPopup').offsetHeight) < (document.getElementById('id_' + sel).offsetTop + document.getElementById('id_' + sel).offsetHeight)){
		     document.getElementById('prodListPopup').scrollTop = ((document.getElementById('id_' + sel).offsetTop +
		                                                              document.getElementById('id_' + sel).offsetHeight) -
		                                                              document.getElementById('prodListPopup').offsetHeight) + 20;
		      }
		  }
		   //console.log(document.getElementById('id_' + sel).offsetTop + document.getElementById('id_' + sel).offsetHeight );
       //document.getElementById('prodListPopup').scrollTop = 0;
		}
		handleST(e){
      this.setState({searchText:e.target.value});
		}
		selectItem(prod){
		  this.props.parent.selectProduct.bind(null,prod)();
      this.setState({searchText:'', selected:0});
		}
    render() {
        var i = 0;

		    if(!this.props.root.state.current_customer || !this.props.root.state.current_customer.products ){
		      return '';
		    }

		    if(!!this.state.searchText){
		      if(this.props.root.autoKey !== this.capture ){
		        this.park = this.props.root.autoKey;
		      }
		      this.props.root.autoKey = this.capture;
          var tbo = <tr><td><div style={{background:'#fff', fontSize: '20px', padding: '20px', borderBottom: 'solid 4px #07a', textAlign: 'center', boxShadow:'2px 2px 3px rgba(0,0,0,0.2)'}}>Sorry... Can't find any matching Items</div></td></tr>
		      if(this.state.list.length){
		        tbo = this.state.list.map(( prod ) => {
		            if(!prod.composite || this.props.showComposite === true){
                   var cl = '';
                   if(i === this.state.selected){
                     cl = 'selected';
                   }
                   var _id = 'id_' + i.toString();
                   i++;
                   var stock;
                   if(prod.stock_alloc && this.props.showAllocated === true){
                     stock = <span title="Stock Level: Brackets denote stock after fulfilling all outstanding and unpacked orders." className="stockCount">{prod.stock} ({prod.stock-prod.stock_alloc}) </span>
                   }
                   else {
                     stock = <span title="Stock Level" className="stockCount">{prod.stock}</span>
                   }
                   return <tr className={cl} id={_id} key={_id} onClick={this.selectItem.bind(null, prod)}><td title="SKU (Stock Keeping Unit)">{prod.sku}</td><td title="Product Name">{prod.name}</td><td>{stock}</td></tr>
                }
                return '';
            });
          }
          return (
            <div>
              <input id="prod_search" value={this.state.searchText} onChange={FX.formHandler.bind(this, 'searchText')}/>
              <div id="prodListPopup" className="prodListPopup"   onClick={(e) => {console.log(e); e.stopPropagation(); e.preventDefault(); this.setState({searchText:''})}} >
              <button className="closePopup" onClick={() => {this.setState({searchText:''})}}>X</button>
              <table id="product_list">
                <tbody>
                  {tbo}
                </tbody>
              </table>
              </div>
            </div>
          )
        }
        else {
          if(this.park && this.props.root.autoKey !== this.park){
		        this.props.root.autoKey = this.park;
		        console.log(this.park);
		      }
        }
        return (
          <div>
            <input id="prod_search" placeholder="Product Search" value={this.state.searchText} onChange={FX.formHandler.bind(this, 'searchText')}/>
          </div>
        );
    }
	}
export default SearchBox;



// WEBPACK FOOTER //
// ./src/SearchBox.js